// 更新loading状态
export const UPDATE_LOADING = 'loading/UPDATE_LOADING'
// tabbar显示状态
export const SHOW_TABBAR = 'global/SHOW_TABBAR';
// header显示状态
export const SHOW_HEADER = 'global/SHOW_HEADER';
export const IS_CHECKED = 'global/IS_CHECKED';


// WEBPACK FOOTER //
// ./src/store/mutation-types.js